import { render, staticRenderFns } from "./ActivePatientCard.vue?vue&type=template&id=5b1d1826&scoped=true"
import script from "./ActivePatientCard.vue?vue&type=script&lang=js"
export * from "./ActivePatientCard.vue?vue&type=script&lang=js"
import style0 from "./ActivePatientCard.vue?vue&type=style&index=0&id=5b1d1826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1d1826",
  null
  
)

export default component.exports